import React from 'react'
import styles from './style.module.styl'

const Header: React.FC = () => {
  return (
    <div className={styles.header}>
      大数据可视化中心
    </div>
  )
}

export default Header
